import React from 'react';
import { Button, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { CreateQuestionInterface, CreateStepInterface } from 'pages/Activities/activities.context';
import AddIcon from '@mui/icons-material/Add';
import CustomIcon from 'components/Icon/CustomIcon';
import Step from 'pages/Activities/ActivityWizard/StepDetails/Step';
import { useActivityWizardContext } from 'pages/Activities/ActivityWizard/activityWizard.context';
import EmptyData from 'components/Messages/EmptyData/EmptyData';
import { Box } from '@mui/system';
import { QuestionType } from '__generated__/graphql';

function getNextStepSortOrder(steps?: CreateStepInterface[]): number {
  if (!steps?.length) {
    return 0;
  }

  return Math.max(...steps.map((x) => x.sortOrder || 0)) + 1;
}

export const defaultStep: CreateStepInterface = {
  subject: '',
  description: '',
  estimatedTimeToComplete: 0,
  requiresReview: false,
  isRequired: false,
  removedFileIds: [],
  sortOrder: 0,
};

const defaultQuestion: CreateQuestionInterface = {
  questionDetail: '',
  type: QuestionType.Text,
  questionChoices: [],
};

const StepDetails = (): JSX.Element => {
  const theme = useTheme();
  const { setNewActivity, newActivity } = useActivityWizardContext();

  const addStep = () => {
    setNewActivity({
      ...newActivity,
      steps: [
        ...newActivity.steps,
        { ...defaultStep, sortOrder: getNextStepSortOrder(newActivity.steps) },
      ],
    });
  };

  const addQuestion = () => {
    setNewActivity({
      ...newActivity,
      steps: [
        ...newActivity.steps,
        {
          ...defaultStep,
          question: defaultQuestion,
          sortOrder: getNextStepSortOrder(newActivity.steps),
        },
      ],
    });
  };

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        mt={5}
        sx={{
          backgroundColor: theme.colors.white,
          borderRadius: '0.375rem',
          padding: '2rem',
          maxWidth: '75rem',
          mx: 'auto',
          marginBottom: '1.5rem',
        }}
      >
        {newActivity.steps.length ? (
          newActivity.steps.map((step, i) => (
            <Step key={i} stepIndex={i} question={!!step.question} />
          ))
        ) : (
          <Box my={5}>
            <EmptyData dataType='step' />
          </Box>
        )}
        <Grid container>
          <Grid item xs={0} md={2} />
          <Grid
            item
            xs={12}
            md={8}
            display='flex'
            justifyContent={newActivity.steps.length ? 'flex-start' : 'center'}
          >
            <Button onClick={addStep} sx={{ marginRight: '1rem' }}>
              <CustomIcon icon={<AddIcon />} />
              Add Task
            </Button>
            <Button onClick={addQuestion}>
              <CustomIcon icon={<AddIcon />} />
              Add Question
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default StepDetails;
